<script>
import Textblock from '../block/BlockText'
import Textlist from '../block/BlockTextlist'
import Timeblock from '../block/BlockTime'
import Dateblock from '../block/BlockDate'
import Disclaimer from '../block/BlockDisclaimer'
import Imageblock from '../block/BlockImage'
import Fineprint from '../block/BlockFineprint'
import ProductTable from '../table/TableOnepagerProducts'
import ShortlistTable from '../table/TableShortlistProducts'
import Provision from '../block/BlockProvision'
import Pagetitle from '../block/BlockPageTitle'
import Footnotes from '../block/BlockFootnotes'
import ChancesRisks from "../block/BlockChancesRisks"
import Pagebreak from "../block/BlockPagebreak"


const BlockMixin = {
  components: {
    ChancesRisks,
    Textblock,
    Textlist,
    Imageblock,
    Timeblock,
    Disclaimer,
    Fineprint,
    ProductTable,
    ShortlistTable,
    Provision,
    Pagetitle,
    Footnotes,
    Pagebreak,
    Dateblock,
  }
}

export default BlockMixin
</script>



// WEBPACK FOOTER //
// BlockMixin.vue?50ee929a